export { VpHookFormInput } from './VpHookFormInput';
export { VpInput } from './VpInput';
export { VpCheckbox } from './VpCheckbox';
export { VpRadio } from './VpRadio';
export { VpSelect } from './VpSelect';
export { VpStripeInput } from './VpStripeInput';
export { VpTagInput } from './VpTagInput';
export { VpHookFormSelect } from './VpHookFormSelect';
export { VpHookFormCheckbox } from './VpHookFormCheckbox';
export { VpHookFormSwitch } from './VpHookFormSwitch';
export { VpHookFormColorInput } from './VpHookFormColorInput';
export { VpHookFormRatingInput } from './VpHookFormRatingInput';
export { VpDropzone } from './VpDropzone';



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/index.js